<template>
  <div>
    <app-header title="">
      <template v-slot:actions>
        <button
          type="button"
          class="btn btn-primary mt-2 mt-xl-0"
          v-c-modal:modal="{}"
        >
          <i class="far fa-plus"></i> Project Agreement
        </button>
      </template>
    </app-header>

    <div class="container my-5">

      <c-data-list ref="dataList" :items="agreements">
        <template v-slot:columns>
          <div class="col-12 col-lg-8">
            <p>Name</p>
          </div>
          <div class="col-12 col-lg-4 text-end">
            <p>Version</p>
          </div>
        </template>
        <template v-slot:default="slotProps">
           <router-link tag="a" :to="{ name: 'settings.project-agreements.show', params: { 'project_agreement_id': slotProps.item.id }}">
            <div class="row">
              <div class="col-8">
                <p class="truncate client">{{slotProps.item.title}} <span v-if="slotProps.item.default" class="badge badge-pill bg-primary">Default</span></p>
              </div>
              <div class="col-4 text-end">
                <p>{{slotProps.item.version}}</p>
              </div>
            </div>
          </router-link>
        </template>
      </c-data-list>
    </div>

    <project-agreement-modal ref="modal" title="Create Project Agreement" :agreement="newAgreement" @created="newProjectAgreementCreated" mode="create" />

  </div>
</template>

<script>

import { http } from 'utils'
import { mapState, mapActions } from 'vuex'
import ProjectAgreementModal from './project-agreements/ProjectAgreementModal'

export default {

  components: {
    ProjectAgreementModal
  },

  data: function () {
    return {
      link: null,
      data: [],
      newAgreement: {
          title: ""
      },
    }
  },

  computed: {
    ...mapState('projectAgreement', {agreements: 'list', pagination: 'pagination'})
  },

  created: function() {
      this.getAgreements()
  },

  mounted() {


  },
  methods: {
    ...mapActions('projectAgreement', {getAgreements: 'getList', getAgreementsForNextPage: 'getListForNextPage'}),

    newProjectAgreementCreated(newAgreement) {
      this.getAgreements()
    }
  }
}
</script>
